export enum PromiseResult {
  Fulfilled = "fulfilled",
  Rejected = "rejected",
}
